const STORAGE_KEY = 'console.email-link-pending';

/**
 * Persists the address an email-link sign-in was requested for (SL-0045 Activity 2), mirroring
 * `src/lib/active-context-store.ts`: a pure module with no React import. The address must survive
 * the round trip through the user's inbox because `signInWithEmailLink` requires it on the return
 * leg and it is not recoverable from the link itself. Storage failures and malformed values
 * degrade to `null` — the provider then falls back to the cross-device re-prompt
 * (`emailLinkOutcome: 'email-required'`) rather than throwing.
 */
export function readPendingEmail(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) {
      return null;
    }
    const trimmed = raw.trim();
    return trimmed.length > 0 ? trimmed : null;
  } catch {
    return null;
  }
}

/** Stores the pending address, or removes the key when `null`. Failures are swallowed for the
 * same reason `readPendingEmail` catches: a private-mode or quota failure must degrade to the
 * cross-device re-prompt on the return leg, not fail the request that already sent the email. */
export function setPendingEmail(email: string | null): void {
  try {
    if (email === null) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, email);
    }
  } catch {
    // Degradation path documented above.
  }
}
